import styled, { keyframes } from 'styled-components';
import UITile from 'UIComponents/tile/UITile';
import UITileSection from 'UIComponents/tile/UITileSection';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const roundShimmerKeyframes = keyframes(["0%{background-position:-40px 0;}100%{background-position:40px 0;}"]);

// Hardcoded colors because the Canvas theme doesn't have semantic colors
// specific to icons, so this is something for the team to revisit later
// as there may be other valid theme tokens that could be used instead.
const backgroundGradient = `linear-gradient(106deg, #f5f8fa, #eaf0f6, #f5f8fa, #f5f8fa)`;
const StyledIcon = styled.div.withConfig({
  displayName: "DataSourceSkeleton__StyledIcon",
  componentId: "gke9qu-0"
})(["flex-basis:46px;flex-grow:0;flex-shrink:0;border-radius:", ";width:46px;height:46px;background-image:", ";animation:", " 15000ms linear 0s infinite normal forwards;"], ({
  theme
}) => theme.borderRadius[100], backgroundGradient, roundShimmerKeyframes);
const textShimmerKeyframes = keyframes(["0%{background-position:-300px 0;}100%{background-position:300px 0;}"]);
const StyledHeader = styled.div.withConfig({
  displayName: "DataSourceSkeleton__StyledHeader",
  componentId: "gke9qu-1"
})(["border-radius:20px;width:150px;height:20px;margin-left:", ";margin-bottom:", ";background:", ";animation:", " 15000ms linear 0s infinite normal forwards;"], ({
  theme
}) => theme.space[250], ({
  theme
}) => theme.space[250], backgroundGradient, textShimmerKeyframes);
const StyledText = styled.div.withConfig({
  displayName: "DataSourceSkeleton__StyledText",
  componentId: "gke9qu-2"
})(["border-radius:20px;width:200px;height:20px;margin-left:", ";background:", ";animation:", " 17500ms linear 0s infinite normal forwards;"], ({
  theme
}) => theme.space[250], backgroundGradient, textShimmerKeyframes);
const DataSourceSkeleton = () => {
  return /*#__PURE__*/_jsx(UITile, {
    compact: true,
    children: /*#__PURE__*/_jsx(UITileSection, {
      children: /*#__PURE__*/_jsxs(TFlex, {
        justify: "start",
        align: "center",
        "data-test-id": "data-source-select-skeleton",
        children: [/*#__PURE__*/_jsx(StyledIcon, {}), /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(StyledHeader, {}), /*#__PURE__*/_jsx(StyledText, {})]
        })]
      })
    })
  });
};
export default DataSourceSkeleton;